import { ActiveRecord, sources } from '@mysidewalk/active-record';
/**
 * @memberof geodata
 */
class DataReferenceCollectionResource extends ActiveRecord {
}
DataReferenceCollectionResource.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordJSONAPISource,
    options: {
        responseMetadataPropertyName: null,
        transformResponse: (response) => {
            if (response.headers.get('Content-Type') == 'application/json') {
                return response.json();
            }
            return Promise.resolve(response);
        },
        transformResponseRecords: (body) => {
            return [body];
        },
    },
};
export default DataReferenceCollectionResource;
